// extracted by mini-css-extract-plugin
export var modal = "_ip-0";